import React, { useState, useEffect } from "react";
import { baseUrl } from "../../baseUrl";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import style from '../../components/admin/exam/ExamResult.module.css'
import ExamInstruction from "./ExamInstruction";
import swal from "sweetalert"
import Swal2 from 'sweetalert2';
import { useAuth } from "../../AuthContext";
import StartTPT from "./StartTPT";
import AdWithCountdown from "../AdWithCountdown";
import { TailSpin } from "react-loader-spinner";

const StartExam = () => {
  const { email, examId } = useParams();
  const [exam, setExam] = useState(null);
  const [studentExam,setStudentExam]=useState({})
  const [examStarted, setExamStarted] = useState(false);
  const [timeLeft, setTimeLeft] = useState(null);
  const [timer, setTimer] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedSubject, setSelectedSubject] = useState("");
  const [submit,setSubmit]=useState(false)
  const [read,setRead]=useState(false)
  const {user}=useAuth()
  const examDuration = exam?.timeLimit*60; 
  const [processing,setProcessing] = useState(false)
  const [loading,setLoading] =useState(false);
  const [starting, setStarting] = useState(false);
  const [adFinished, setAdFinished] = useState(false);
  const handleAdFinish = () => {
    setAdFinished(true);
  };

  const getExam = async () =>{
    setLoading(true)
    try {
      const exam = await axios
        .get(`${baseUrl}/exam/get?id=${examId}`)
        setExam(exam.data)
    } catch (err) {
      console.log(err)
    }
    finally{
      setLoading(false)
    }
  }

  useEffect(() => {
    getExam()
    axios.get(`${baseUrl}/student/exam/get-one?email=${email}&examId=${examId}`)
      .then(res => { setStudentExam(res.data.exam) })
      .catch(err => console.log(err))
  }, [examId,user]);

  const getQuestionNumber = (subject, index) => {
    const sectionRanges = {
      "Physics": { start: 1, end: 45 },
      "Chemistry": { start: 46, end: 90 },
      "Biology": { start: 91, end: 180 },
    };
  
    const sectionKey = subject;
    const sectionRange = sectionRanges[sectionKey];
  
    if (sectionRange) {
      return sectionRange.start + index; // Adds the index to the start of the section's range
    }
  
    return null; // If section is not found
  };
  
  // Start Exam and fetch questions
  const startExam = async () => {
    if(read){
      setStarting(true);
      try {
        const response = await axios.post(`${baseUrl}/student/exam/start-exam`, {
          email: email,
          examId: examId,
        });

        const data = response.data;
        if (data.success) {
          setExamStarted(true);
          setTimeLeft(examDuration);
          setQuestions(data.exam.questions);
          // Initialize answer tracking for each question
          const initialAnswers = data.exam.questions.reduce((acc, question, index) => {
            acc[question._id] = { answer: null, status: "unattempted",review:false, questionId: question._id, correct: question.correct };
            return acc;
          }, {});
          setAnswers(initialAnswers);
        } else {
          alert(data.message || "Unable to start the exam");
        }
      } catch (error) {
        console.error("Error starting exam:", error);
        alert("An error occurred while starting the exam");
      } finally {
        setStarting(false)
      }
    }
    else{
      swal({
        title: "Confirmation needed!",
        text: 'Please click given check box to confirm you have read instructions',
        icon: "warning",
        dangerMode: true,
      })
    }
  };

  // Timer countdown function
  useEffect(() => {
    if (examStarted && timeLeft > 0) {
      const interval = setInterval(() => {
        setTimeLeft((prevTimeLeft) => {
          if (prevTimeLeft <= 1) {
            clearInterval(interval);
            submitExam();
            return 0;
          }
          return prevTimeLeft - 1;
        });
      }, 1000);
      setTimer(interval);

      return () => clearInterval(interval);
    }

    return () => clearInterval(timer);
  }, [examStarted, timeLeft]);

  const submitExam = async () => {
    setSubmit(true)
    if(timeLeft<=1){
      if (timeLeft <= 1) {
        Swal2.fire({
          title: "Time's up! Exam Over.",
          icon: "warning",
          dangerMode: true,
          allowOutsideClick: false, 
          allowEscapeKey: false, 
          showCancelButton: false, 
          confirmButtonText: 'Proceed', 
          confirmButtonColor: '#28a745', 
        }).then(async(result) => {
          if (result.isConfirmed) {
            if(exam.course.type==='TPT'){
              try {
                setProcessing(true)
                const response = await axios.post(`${baseUrl}/student/exam/submit-tpt-exam`, {
                  email: email,
                  examId: examId,
                  answers: Object.values(answers),
                });
          
                if (response.data.success) {
                  setProcessing(false)
                  window.location.href = `/exam/tpt-results/${email}/${examId}`;
                } else {
                  setProcessing(false)
                  alert(response.data.message || "Unable to submit the exam");
                }
              } catch (error) {
                console.error("Error submitting exam:", error);
                alert("An error occurred while submitting the exam");
              }
            }else{
              try {
                setProcessing(true)
                const response = await axios.post(`${baseUrl}/student/exam/submit-exam`, {
                  email: email,
                  examId: examId,
                  answers: Object.values(answers),
                });
          
                if (response.data.success) {
                  setProcessing(false)
                  window.location.href = `/exam/results/${email}/${examId}`;
                } else {
                  setProcessing(false)
                  alert(response.data.message || "Unable to submit the exam");
                }
              } catch (error) {
                console.error("Error submitting exam:", error);
                alert("An error occurred while submitting the exam");
              }
            }
          }
        });
      }
      
    }
    else{
      swal({
        title: "Are you sure?",
        text: `Make sure you visited all sections and attempted all required question, \n\nClick "Re-Check" to check all question \n\nClick "Proceed" if you have already checked all questions and proceed with submission`,
        icon: "warning",
        dangerMode: true,
        buttons: {
          cancel: {
            text: "Re-check",
            value: null,
            visible: true,
            className: "btn btn-light",
            closeModal: true
          },
          confirm: {
            text: "Proceed",
            value: true,
            visible: true,
            className: "btn btn-success", // Optional custom styling
            closeModal: true
          }
        },
    })
        .then(async(willSubmit) => {
            if (willSubmit) {
              if(exam.course.type==='TPT'){
                try {
                  setProcessing(true)
                  const response = await axios.post(`${baseUrl}/student/exam/submit-tpt-exam`, {
                    email: email,
                    examId: examId,
                    answers: Object.values(answers),
                  });
            
                  if (response.data.success) {
                    setProcessing(false)
                    window.location.href = `/exam/tpt-results/${email}/${examId}`;
                  } else {
                    setProcessing(false)
                    alert(response.data.message || "Unable to submit the exam");
                  }
                } catch (error) {
                  console.error("Error submitting exam:", error);
                  alert("An error occurred while submitting the exam");
                }
              }else{
                try {
                  setProcessing(true)
                  const response = await axios.post(`${baseUrl}/student/exam/submit-exam`, {
                    email: email,
                    examId: examId,
                    answers: Object.values(answers),
                  });
            
                  if (response.data.success) {
                    setProcessing(false)
                    window.location.href = `/exam/results/${email}/${examId}`;
                  } else {
                    setProcessing(false)
                    alert(response.data.message || "Unable to submit the exam");
                  }
                } catch (error) {
                  console.error("Error submitting exam:", error);
                  alert("An error occurred while submitting the exam");
                }
              }
            }
        }); 
    }
  };

  const handleOptionChange = (questionIndex, option, idx) => {
    const newAnswers = { ...answers };
    const currentQuestion = filteredQuestions[questionIndex];
    const questionId = currentQuestion._id;
     newAnswers[questionId] = {
      ...newAnswers[questionId], 
      questionId:questionId,
      section:filteredQuestions[currentQuestionIndex].section,
      answer: option,
      correct:filteredQuestions[currentQuestionIndex].correct,
      selectedOptionNumber: idx + 1,
      status: "attempted",
    };
  
    setAnswers(newAnswers);
  };

  const handleMarkForReview = (questionIndex) => {
    const newAnswers = { ...answers };
    const review=newAnswers[questionIndex]?.review
    newAnswers[questionIndex].review =review?false:true
    setAnswers(newAnswers);
  };
  const handleNavigateToQuestion = (index) => {
    setCurrentQuestionIndex(index);
  };


  const formatTime = (timeInSeconds) => {
    const hours = Math.floor(timeInSeconds / 3600); // 3600 seconds in an hour
    const minutes = Math.floor((timeInSeconds % 3600) / 60); // Remaining minutes
    const seconds = timeInSeconds % 60; // Remaining seconds
    
    // Format the result as "hh:mm:ss"
    return `${hours}:${minutes < 10 ? "0" + minutes : minutes}:${seconds < 10 ? "0" + seconds : seconds}`;
  };

  // useEffect(() => {
  //   const handleBeforeUnload = (event) => {
  //     if (examStarted) {
  //       const message =
  //         "You are in the middle of an exam. Are you sure you want to leave?";
  //       event.returnValue = message;
  //       return message;
  //     }
  //   };

  //   window.addEventListener("beforeunload", handleBeforeUnload);

  //   return () => {
  //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //   };
  // }, [examStarted]);
  useEffect(() => {
    if(!submit){
          // Push a new state into the browser history to block the back button
    var handleBeforeUnload = (event) => {
      // Prevent default behavior (if needed)
      event.preventDefault();
      event.returnValue = ''; // For some browsers like Chrome
    };

    // Block the back navigation by modifying history state
    const blockBackButton = () => {
      window.history.pushState(null, '', window.location.href);  // Push current state to history
      window.history.forward();  // Move forward in history, so user cannot go back
    };

    // Push a new history state on page load
    window.history.pushState(null, '', window.location.href);
    
    // Attach event listeners
    window.onpopstate = blockBackButton;
    window.addEventListener('beforeunload', handleBeforeUnload);
    }

    // Clean up the listeners when component unmounts
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.onpopstate = null;
    };
  }, [submit]);
  const groupedQuestions = {};
  questions.forEach((question) => {
    if(question.subject==='Physics'){
        const subjectPart = 'Physics';
        if (!groupedQuestions[subjectPart]) {
          groupedQuestions[subjectPart] = [];
        }
        groupedQuestions[subjectPart].push(question);
    }
    if(question.subject==='Chemistry'){
        const subjectPart = 'Chemistry';
        if (!groupedQuestions[subjectPart]) {
          groupedQuestions[subjectPart] = [];
        }
        groupedQuestions[subjectPart].push(question);
    }
    if(question.subject==='Biology'){
        const subjectPart = 'Biology';
        if (!groupedQuestions[subjectPart]) {
          groupedQuestions[subjectPart] = [];
        }
        groupedQuestions[subjectPart].push(question);
    }
  });

  
  const availableSubjects = Object.keys(groupedQuestions);
  useEffect(() => {
    if (availableSubjects.length > 0 && !selectedSubject) {
      const defaultSubject = availableSubjects[0]; 
      setSelectedSubject(defaultSubject);
    }
  }, [availableSubjects, selectedSubject]);

  const filteredQuestions = (groupedQuestions[selectedSubject] || []).sort((a, b) => {
    return a.number - b.number;
  });

  const handleSubjectChange = (newSubject) => {
    setSelectedSubject(newSubject);
    setCurrentQuestionIndex(0);
  };
  if (loading) return (
    <div
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 3,
        color: '#fff',
        fontSize: '24px',
        fontWeight: 'bold',
        backgroundColor: 'rgba(0,0,0,0.5)',
        padding: '10px 20px',
        borderRadius: '10px',
      }}
    >
      <TailSpin
        visible={true}
        height="80"
        width="80"
        color="#8000D5"
        ariaLabel="tail-spin-loading"
        radius="1"
        wrapperStyle={{}}
        wrapperClass=""
      />
    </div>
  )

  return (
    <>
      {
        exam&&exam?.course?.type === 'TPT' ?
          <StartTPT
            exam={exam}
            examStarted={examStarted}
            timeLeft={timeLeft}
            startExam={startExam}
            submitExam={submitExam}
            questions={questions}
            answers={answers}
            currentQuestionIndex={currentQuestionIndex}
            setCurrentQuestionIndex={setCurrentQuestionIndex}
            selectedSubject={selectedSubject}
            setSelectedSubject={setSelectedSubject}
            handleOptionChange={handleOptionChange}
            handleMarkForReview={handleMarkForReview}
            read={read}
            setRead={setRead}
            studentExam={studentExam}
            availableSubjects={availableSubjects}
            filteredQuestions={filteredQuestions}
            handleSubjectChange={handleSubjectChange}  
            handleNavigateToQuestion={handleNavigateToQuestion}
            getQuestionNumber={getQuestionNumber}
            starting={starting}
            processing={processing}
          /> : (
            exam&&exam?.course?.type === 'Mock Test' ?
            // adFinished ? (
              <div className="start-exam">
              {!examStarted ? (
                <div className="container mt-5">
                  <div className={`${style.instruction} mt-2`}>
                    <h6>Instructions : </h6>
                    <ExamInstruction />
                  </div>
                  <div className="d-flex mt-4 mb-1">
                    <input type="checkbox" onClick={() => setRead(!read)} /> <span className="ml-2">I have read the above instructions.</span>
                  </div>
                  {
                    !studentExam.attempts || studentExam.attempts < exam.attempts ?
                      <button disabled={starting} onClick={startExam} className="start-btn btn btn-primary mt-3">
                        {starting?'Starting ...':'Start Exam'}
                      </button>
                      :
                      <button disabled className="start-btn btn btn-info mt-3">
                        Attempted
                      </button>
                  }
                  <p className="mt-2"><Link to={`/student/${email}`}>Back</Link></p>
                </div>
              ) : (
                <div className="container-fluid">
                  <div className="mt-2 p-3" style={{ backgroundColor: "#8000D5" }}>
                    <h5 className="text-center text-white">Monarch Institute</h5>
                    <h5 className="text-center text-white">NEET - Online Exam</h5>
                    <h5 className="text-center text-white">Exam Name : {exam.examName}</h5>
                  </div>
                  <div className="row">
                    <div className="col-lg-3 col-sm-12">
                      <p className="mt-3 ml-2">
                        <span>
                          <b>Time Left :</b> {formatTime(timeLeft)}
                        </span>
                      </p>
                    </div>
                    <div className="mt-2 col-lg-9 col-sm-12" style={{ justifySelf: 'center' }}>
                      {availableSubjects.map((subject) => (
                        <button
                          key={subject}
                          onClick={() => handleSubjectChange(subject)}
                          className={`btn btn-sm m-1 ${subject === selectedSubject ? "btn-success" : "btn-secondary"}`}
                        >
                          {subject}
                        </button>
                      ))}
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-md-3">
                      <h6>Note : </h6>
                      <button className="btn btn-sm btn-success m-1">Answered</button>
                      <button className="btn btn-sm btn-secondary m-1">Unanswered</button>
                      <button className="btn btn-sm btn-warning m-1">Review</button><br />
                      {filteredQuestions.map((question, index) => (
                        <button
                          key={question._id}
                          style={{ paddingLeft: '6px', paddingRight: '6px', paddingTop: '5px', paddingBottom: '5px' }}
                          className={`btn btn-sm m-1 btn-${answers[question._id]?.status === "attempted" && answers[question._id]?.review === false
                            ? "success"
                            : answers[question._id]?.review === true
                              ? "warning"
                              : "secondary"
                            }`}
                          onClick={() => handleNavigateToQuestion(index)}
                        >
                          {getQuestionNumber(question.subject, index)}
                        </button>
                      ))}
                    </div>

                    <div className="col-md-9">
                      {filteredQuestions.length > 0 && (
                        <div className="question">
                          <span className="fw-bold fs-5">
                            Q {getQuestionNumber(filteredQuestions[currentQuestionIndex].subject, currentQuestionIndex)}
                          </span>
                          <div
                            className="question-preview"
                            dangerouslySetInnerHTML={{
                              __html: filteredQuestions[currentQuestionIndex].question,
                            }}
                          />
                          {filteredQuestions[currentQuestionIndex].options &&
                            filteredQuestions[currentQuestionIndex].options.length > 0 && (
                              <div>
                                {filteredQuestions[currentQuestionIndex].options.map((option, idx) => (
                                  <div key={idx}>
                                    <label className="mr-2">({idx + 1})</label>
                                    <input
                                      className="mr-2"
                                      type="radio"
                                      id={`option-${currentQuestionIndex}-${idx}`}
                                      name={`question-${filteredQuestions[currentQuestionIndex]._id}`}
                                      value={option}
                                      checked={answers[filteredQuestions[currentQuestionIndex]._id]?.answer === option}
                                      onChange={() => handleOptionChange(currentQuestionIndex, option, idx)}
                                    />
                                    <label
                                      htmlFor={`option-${currentQuestionIndex}-${idx}`}
                                      dangerouslySetInnerHTML={{
                                        __html: option,
                                      }}
                                    ></label>
                                  </div>
                                ))}
                              </div>
                            )}
                          <button
                            onClick={() => handleMarkForReview(filteredQuestions[currentQuestionIndex]._id)}
                            className="btn btn-info mt-2 btn-sm"
                          >
                            {answers[filteredQuestions[currentQuestionIndex]._id].review
                              ? "Unmark for review"
                              : "Mark for Review"}
                          </button>
                        </div>
                      )}
                      <div className="mt-3">
                        <button
                          onClick={() => setCurrentQuestionIndex(currentQuestionIndex - 1)}
                          disabled={currentQuestionIndex === 0}
                          className="btn btn-secondary btn-sm"
                        >
                          Previous
                        </button>
                        <button
                          onClick={() => setCurrentQuestionIndex(currentQuestionIndex + 1)}
                          disabled={currentQuestionIndex === filteredQuestions.length - 1}
                          className="btn btn-secondary ml-2 btn-sm"
                        >
                          Next
                        </button>
                      </div>
                      <button disabled={processing} className="mt-5 mb-3 btn btn-success btn-sm" onClick={submitExam}>
                        {processing ? 'Processing ...' : 'Submit Exam'}
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
            // ) : (
            //   <AdWithCountdown onAdFinish={handleAdFinish} />
            // ) 
            : (
                <div className="start-exam">
                  {!examStarted ? (
                    <div className="container mt-5">
                      <div className={`${style.instruction} mt-2`}>
                        <h6>Instructions : </h6>
                        <ExamInstruction />
                      </div>
                      <div className="d-flex mt-4 mb-1">
                        <input type="checkbox" onClick={() => setRead(!read)} /> <span className="ml-2">I have read the above instructions.</span>
                      </div>
                      {
                        !studentExam.attempts || studentExam.attempts < exam.attempts ?
                          <button onClick={startExam} className="start-btn btn btn-primary mt-3">
                            Start Exam
                          </button>
                          :
                          <button disabled className="start-btn btn btn-info mt-3">
                            Attempted
                          </button>
                      }
                      <p className="mt-2"><Link to={`/student/${email}`}>Back</Link></p>
                    </div>
                  ) : (
                    <div className="container-fluid">
                      <div className="mt-2 p-3" style={{ backgroundColor: "#8000D5" }}>
                        <h5 className="text-center text-white">Monarch Institute</h5>
                        <h5 className="text-center text-white">NEET - Online Exam</h5>
                        <h5 className="text-center text-white">Exam Name : {exam.examName}</h5>
                      </div>
                      <div className="row">
                        <div className="col-lg-3 col-sm-12">
                          <p className="mt-3 ml-2">
                            <span>
                              <b>Time Left :</b> {formatTime(timeLeft)}
                            </span>
                          </p>
                        </div>
                        <div className="mt-2 col-lg-9 col-sm-12" style={{ justifySelf: 'center' }}>
                          {availableSubjects.map((subject) => (
                            <button
                              key={subject}
                              onClick={() => handleSubjectChange(subject)}
                              className={`btn btn-sm m-1 ${subject === selectedSubject ? "btn-success" : "btn-secondary"}`}
                            >
                              {subject}
                            </button>
                          ))}
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-md-3">
                          <h6>Note : </h6>
                          <button className="btn btn-sm btn-success m-1">Answered</button>
                          <button className="btn btn-sm btn-secondary m-1">Unanswered</button>
                          <button className="btn btn-sm btn-warning m-1">Review</button><br />
                          {filteredQuestions.map((question, index) => (
                            <button
                              key={question._id}
                              style={{ paddingLeft: '6px', paddingRight: '6px', paddingTop: '5px', paddingBottom: '5px' }}
                              className={`btn btn-sm m-1 btn-${answers[question._id]?.status === "attempted" && answers[question._id]?.review === false
                                ? "success"
                                : answers[question._id]?.review === true
                                  ? "warning"
                                  : "secondary"
                                }`}
                              onClick={() => handleNavigateToQuestion(index)}
                            >
                              {getQuestionNumber(question.subject, index)}
                            </button>
                          ))}
                        </div>

                        <div className="col-md-9">
                          {filteredQuestions.length > 0 && (
                            <div className="question">
                              <span className="fw-bold fs-5">
                                Q {getQuestionNumber(filteredQuestions[currentQuestionIndex].subject, currentQuestionIndex)}
                              </span>
                              <div
                                className="question-preview"
                                dangerouslySetInnerHTML={{
                                  __html: filteredQuestions[currentQuestionIndex].question,
                                }}
                              />
                              {filteredQuestions[currentQuestionIndex].options &&
                                filteredQuestions[currentQuestionIndex].options.length > 0 && (
                                  <div>
                                    {filteredQuestions[currentQuestionIndex].options.map((option, idx) => (
                                      <div key={idx}>
                                        <label className="mr-2">({idx + 1})</label>
                                        <input
                                          className="mr-2"
                                          type="radio"
                                          id={`option-${currentQuestionIndex}-${idx}`}
                                          name={`question-${filteredQuestions[currentQuestionIndex]._id}`}
                                          value={option}
                                          checked={answers[filteredQuestions[currentQuestionIndex]._id]?.answer === option}
                                          onChange={() => handleOptionChange(currentQuestionIndex, option, idx)}
                                        />
                                        <label
                                          htmlFor={`option-${currentQuestionIndex}-${idx}`}
                                          dangerouslySetInnerHTML={{
                                            __html: option,
                                          }}
                                        ></label>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              <button
                                onClick={() => handleMarkForReview(filteredQuestions[currentQuestionIndex]._id)}
                                className="btn btn-info mt-2 btn-sm"
                              >
                                {answers[filteredQuestions[currentQuestionIndex]._id].review
                                  ? "Unmark for review"
                                  : "Mark for Review"}
                              </button>
                            </div>
                          )}
                          <div className="mt-3">
                            <button
                              onClick={() => setCurrentQuestionIndex(currentQuestionIndex - 1)}
                              disabled={currentQuestionIndex === 0}
                              className="btn btn-secondary btn-sm"
                            >
                              Previous
                            </button>
                            <button
                              onClick={() => setCurrentQuestionIndex(currentQuestionIndex + 1)}
                              disabled={currentQuestionIndex === filteredQuestions.length - 1}
                              className="btn btn-secondary ml-2 btn-sm"
                            >
                              Next
                            </button>
                          </div>
                          <button disabled={processing} className="mt-5 mb-3 btn btn-success btn-sm" onClick={submitExam}>
                            {processing ? 'Processing ...' : 'Submit Exam'}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )

          )
      }
    </>
  );
};

export default StartExam;
